import React from 'react';
import { Navigate } from 'react-router-dom';
import { useDreAccess } from '../hooks/useDreAccess';

// Gate da rota /dre: só gerentes cadastrados no DRE (regional ou unidade).
// Diretoria/DECON (somente leitura) entram numa fase posterior.
function DreGuard({ children }) {
  const { isGerente, loading } = useDreAccess();

  if (loading) {
    return (
      <div className="status-card" style={{ textAlign: 'center', padding: 40 }}>
        <span className="status-title">Verificando permissões...</span>
      </div>
    );
  }

  if (!isGerente) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default DreGuard;
